import React from 'react';
import mainlogo from '../logos/logomain.png';

const Navbar = () => {
  return (
    <nav className="bg-white shadow-md">
      <div className="container mx-auto px-6 py-3 flex justify-between items-center">
        <a href="/" className="flex items-center">
          <img src={mainlogo} alt="ChowBuddy Logo" className="h-8 mr-2" />{' '}
        </a>
        <div>
          <a
            href="https://t.me/ChowBuddyBot"
            className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-400 transition duration-300"
            target="_blank"
            rel="noopener noreferrer"
          >
            Start Chatting
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
